module.exports = __webpack_public_path__ + "img/Group127.6bd4867e.png";